var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgMicrosoft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1407_29886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04346 1.04346H11.4782V11.4782H1.04346V1.04346Z",
    fill: "#F35325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.522 1.04346H22.9568V11.4782H12.522V1.04346Z",
    fill: "#81BC06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04346 12.5217H11.4782V22.9565H1.04346V12.5217Z",
    fill: "#05A6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.522 12.5217H22.9568V22.9565H12.522V12.5217Z",
    fill: "#FFBA08"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1407_29886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoft.2ae35116c450b564a1ab134feac69abd.svg";